import { render, staticRenderFns } from "./stu_1LayoutBasic3.vue?vue&type=template&id=7a5fee91&scoped=true"
import script from "./stu_1LayoutBasic3.vue?vue&type=script&lang=js"
export * from "./stu_1LayoutBasic3.vue?vue&type=script&lang=js"
import style0 from "./stu_1LayoutBasic3.vue?vue&type=style&index=0&id=7a5fee91&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5fee91",
  null
  
)

export default component.exports